import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'occupancy-devices',
    template: `
        <div id="test">
            <h4>List of selected date occupancy for device ID {{items[0].Id}}</h4>
            <br>
            <div>Total possible earnings for selected dates is {{totalPrice}}€</div>
            <div>Total device occupancy percentage for selected dates is {{totalOccupancy}}%</div>
            <br>
            <div>Legend: white- free timeslot, blue- occupied timeslot</div>
            <!--<div id="dateTable" class="s-label" *ngFor="let date of items">
                Date:  {{date.Date}}<br>
                Non-reserved Timeslots: {{date.AvailableTimeslots}}<br>
                Reserved Timeslots: {{date.UnavailableTimeslots}}<br>
                Occupancy: {{date.PercentageOccupancy}}%<br>
                Possible earnings: {{date.Price}}€<br>
                <hr>
            </div>-->
            <table>
                <tbody>
                    <td *ngFor="let date of items">
                        <tr>{{date.Date}}</tr>
                        <tr> 
                            <table>
                                <tbody>
                                    <tr *ngFor="let slot of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]">
                                        <td bgcolor="blue" style="color:white" *ngIf="date.UnavailableTimeslots.indexOf(slot)>=0">{{slot}}</td>
                                        <td bgcolor="white" *ngIf="date.UnavailableTimeslots.indexOf(slot)==-1">{{slot}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </tr>
                        <tr>Occupancy:<br> {{date.PercentageOccupancy}}%</tr>
                        <tr>Total Price:<br> {{date.Price}}€</tr>
                    </td>
                </tbody>
            </table>
        </div>  
    `,
    styleUrls:['./occupancydevices.scss'],
  })

// OccupancyStaticDevices is a class for window presentation of occupied timeslots for device-date combo
export class OccupancyStaticDevices implements OnInit {
    @Input() items: any;

    constructor(){
    } 

    ngOnInit(){ 
    }

    ngOnDestroy(){
    }
    
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/dashboard/occupancydevices.ts